module.exports = __webpack_public_path__ + "static/media/7MyMoneyMatters-ENG.b45dc497.JPG";